export default "__VITE_ASSET__DwvdYckg__"